import { HTMLGenricComponent } from "./../htmlComponent/HTML-Genric-Component.JSON";

export class HTMLDisplayComponentRequestJSON {
    displayLable: String;
    componentTypeID: Number;
    selectedDropDown: Number;
    selectedRadio: Number;
    selectedCheckBox: Number[];
    inputHTMLComponentJSONList: HTMLGenricComponent[];

}